import graphql__da82cc3fb5e1a7eaba12 from "./__generated__/AnswerPreviewText_answer.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

const AnswerPreviewText = props => {
  return props.answer.content || "-";
};

export default createFragmentContainer(AnswerPreviewText, {
  answer: graphql__da82cc3fb5e1a7eaba12
});
